import { render, staticRenderFns } from "./setDesensitizationRules.vue?vue&type=template&id=a969dd58&scoped=true&"
import script from "./setDesensitizationRules.vue?vue&type=script&lang=js&"
export * from "./setDesensitizationRules.vue?vue&type=script&lang=js&"
import style0 from "./setDesensitizationRules.vue?vue&type=style&index=0&id=a969dd58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a969dd58",
  null
  
)

export default component.exports